export class Theme {

  private readonly _id: string;
  private readonly _sortOrder: string;
  private readonly _title: string;
  private readonly _parentId : string;
  private readonly _rootId : string;

  constructor(entity) {
    this._id = entity.ID;
    this._sortOrder = entity.S_ORDER;
    this._title = entity.TITEL;
    this._parentId = entity.PARENT_ID;
    this._rootId = entity.ROOT_ID;
  }

  public static sort(themes: Theme[]) {
    themes.sort(((a: Theme, b: Theme) => {
      return a.sortOrder.localeCompare(b.sortOrder);
    }));
  }

  get id(): string {
    return this._id;
  }

  get sortOrder(): string {
    return this._sortOrder;
  }

  get title(): string {
    return this._title;
  }

  get parentId(): string {
    return this._parentId;
  }

  get rootId(): string {
    return this._rootId;
  }
}
